import { useMemo } from 'react';

import useMatchmakerQuestion from './useMatchmakerQuestion';

export default function useApplicationFormsAnswer(filters) {
  const {
    inputs: { applicationForms },
  } = useMatchmakerQuestion({
    key: 'applicationForms',
    initialState: state => state.applicationForms,
  });

  const selectedApplicationFormCode = useMemo(
    () =>
      filters.applicationForms.find(item => item.id === +applicationForms)
        ?.code,
    [filters.applicationForms, applicationForms]
  );

  return { selectedApplicationFormCode };
}
